<template>
  <v-app>
    <component :is="layout">
    </component>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  computed: {
    layout() {
      return `${(this.$route.meta.layout || 'clean')}-layout`;
    },
  },
  data() {
    return {};
  },
};
</script>